import { SVGProps, Ref, forwardRef } from 'react';

export const CheckOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.273 15.454 19.727 5 21 6.273 9.273 18 3 11.727l1.273-1.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckOutlinedSize24Glyph.displayName = 'CheckOutlinedSize24Glyph';
